/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
import { trackEvent } from 'utils/tracking/tracking';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/content/shared/questionset/shared/question/question_styles';
import { createStyles } from 'utils/styles';
import {getElementCSSProperty} from 'utils/styles';
import {log} from 'utils/logger';
const sheet = createStyles(styles, {link:true});


/* ========== ~~~~~~~~~~ QUESTION ~~~~~~~~~~ ========== */
// STATELESS FUNCTIONAL COMPONENT
// used to create markup structure and render UI
// doesn't need all the lifecycle functions attached
class Question extends Component {
    constructor(props) {
        super(props);

        // state to store FontSize of the question.
        // Styles of this component depend on whether or not the rewards are enabled/permitted for the embed.
        // Sets initial values based off the rewards settings and status.
		this.questionEl = null; // stores the DOM elemnt of question container
		this.state = {
			quesSize: 'standard',
			extendHeight: 'none'
		}; // initial size of the question
		this.availableQuesSizes = ['standard', 'medium', 'small', 'xsmall', 'xxsmall', 'xxxsmall', 'x4small', 'x5small', 'x6small', 'x7small', 'x8small']; // array of all available font sizes
        sheet.update(props.rewardsEnabled && props.rewardsPermitted);
        this.handleEmbedResize = this.handleEmbedResize.bind(this);
    }

    componentDidMount() {
        // ::: tracking: question loaded ::: //
        trackEvent({ type: 'load', name: 'ceuContentLoad', props: this.props, additionalProps: { question: this.props.frameData.question }});
        // called here so that the font can be resize as soon as it loads.
        this.adjustFontSize({ resetSize: false }); log('called did mount');
        // add embed resize listener to adjust question font size when the user resizes their browser window
        this.addEmbedResizeListener()
    }

    componentDidUpdate(prevProps, prevState) {
        this.adjustStylesForRewards(prevProps);
        this.adjustStylesOnTextChange(prevProps);
		this.adjustFontSizeOnStateChange(prevState);
	}

    componentWillUnmount() {
    	// remove embed resize listener
    	this.removeEmbedResizeListener()
	}

    adjustStylesForRewards(prevProps) {
        if (this.props.rewardsEnabled && this.props.rewardsPermitted !== prevProps.rewardsPermitted) {
            sheet.update(this.props.rewardsPermitted);
            this.adjustFontSize({ resetSize: true });
        }
    }

    adjustStylesOnTextChange(prevProps) {
        if (prevProps.frameData.question.text !==  this.props.frameData.question.text) this.adjustFontSize({ resetSize: true })
	}

	adjustFontSizeOnStateChange(prevState) {
        // Readjusts font size till question's text fits into the container
        if(this.state.quesSize !== prevState.quesSize && this.state.quesSize !== 'x8small') this.adjustFontSize({ resetSize: false });
	}

	addEmbedResizeListener = () => {
        window.addEventListener('resize', this.handleEmbedResize, true);
	};

    removeEmbedResizeListener = () => {
        window.removeEventListener('resize', this.handleEmbedResize, true);
	};

	handleEmbedResize() {
        this.adjustFontSize({ resetSize: true })
	}

	// the current height and width of the question elements are grabbed and checked here and font size is adjusted accordingly.
	// Now we have the exact height of question element and so we can adjust the font size accordingly.
	// in very rare cases, this function will be called more than 2 times. So no loop here.
	adjustFontSize({ resetSize }) {
    	let currQuesSize = this.state.quesSize;
    	const currQuesSizeIndex = this.availableQuesSizes.indexOf(currQuesSize);
		const questionElDimentions = this.getQuestionContainerDimensions();
    	if(this.questionEl && currQuesSize !== 'x8small' && questionElDimentions.height !== 0 && questionElDimentions.width !== 0) {
    		const heightDifference = questionElDimentions.height - this.getQuestionElementDimensions().height;
            log('QUESTION RESIZE:', 'heightDifference', heightDifference);
            if (heightDifference < 4 ) {
    			currQuesSize = this.availableQuesSizes[currQuesSizeIndex + 1] ? this.availableQuesSizes[currQuesSizeIndex + 1] : currQuesSize;
                heightDifference < -1 ? this.setQuestionSize(currQuesSize) : this.extendQuestionHeight(heightDifference);
			} else if (resetSize) {
                this.setQuestionSize('standard');
			}
        }
	}

	setQuestionSize = currQuesSize => {
		this.setState({ quesSize: currQuesSize });
    };

    extendQuestionHeight = heightDifference => this.isTextualQuestion() ?
		this.setState({ extendHeight: heightDifference < -1 ? 'large' : 'small' }) : null;

	getQuestionContainerDimensions = () => {
		const el = this.questionEl;
		let height = el.clientHeight - parseInt(getElementCSSProperty(el, "padding-top"));
		return { width: el.clientWidth, height: height };
	};

	getQuestionElementDimensions = () => {
		const el = this.questionEl.firstChild;
		return { width: el.clientWidth, height: el.clientHeight };
	};

	isTextualQuestion = () => ['text1', 'text2'].includes(this.props.frameData.question.type);

	getTextBasedClass = () => this.isTextualQuestion() ? `text-${this.props.frameData.answers.length}` : ``;

	render() {
	    return(
	    	<div id={this.props.frameData.question.id} className={`${sheet.classes.question} question ${this.getTextBasedClass()} large-${this.props.enlargedFont} extended-${this.state.extendHeight}`} ref={(input) => this.questionEl = input}>
				<h3 className={`text ${this.state.quesSize}`} >{this.props.frameData.question.text}</h3>
			</div>
	    );
	}
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Question;
